<div class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">Riesgos</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT TOOLBAR
            <div class="toolbar px-24 py-8">
                <span>Riesgos</span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24">

                <button mat-button (click)="openDialog('Add',{})" mat-flat-button color="primary" class="add-row">Agregar</button>
                <button  mat-button (click)="print()" mat-flat-button color="primary" class="add-row">
                  <mat-icon  aria-hidden="false" aria-label="print" >print</mat-icon>
                </button>
                <table mat-table [dataSource]="dataSource" #mytable class="my-table mat-elevation-z8">

                  <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->
                      <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                          <mat-checkbox (change)="$event ? masterToggle($event) : null"
                                        [checked]="isAllItemsSelected"
                                        [indeterminate]="selection.hasValue() && !isAllItemsSelected"
                                        >
                          </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                          <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)"
                                        >
                          </mat-checkbox>
                        </td>
                      </ng-container>

                  <!-- User Column -->
                  <ng-container matColumnDef="nombre">
                    <th mat-header-cell *matHeaderCellDef> Nombre. </th>
                    <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Acción </th>
                    <td mat-cell *matCellDef="let element" class="action-link">
                      <a (click)="openDialog('View',element)">Ver</a>
                      <span *ngIf="!element.bloqueado"> | </span>
                      <a (click)="openDialog('Update',element)" *ngIf="!element.bloqueado">Editar</a>
                      <span *ngIf="!element.bloqueado"> | </span><!--
                      <a (click)="openDialog('Duplicate',element)">Duplicar</a>
                      <span *ngIf="!element.bloqueado"> | </span>-->
                      <a (click)="openDialog('Delete',element)" *ngIf="!element.bloqueado">Eliminar</a>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <mat-paginator #paginator [length]="elementCount" [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="basicSlice"
            (page)="OnePageChange($event)" showFirstLastButtons></mat-paginator>

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
